import React from "react";
import "./styles.scss";

const SvgBrewBarIcon = (props) => (
    <div className="brewbar-icon">
            <svg className="amenities-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.58 26.58"  style={{ fill: props.fill }}><path d="M1.48,26.58a1.46,1.46,0,0,1-1.06-.42,1.54,1.54,0,0,1,0-2.11,1.46,1.46,0,0,1,1.06-.42H22.15a1.48,1.48,0,1,1,0,2.95Zm4.43-5.91a5.65,5.65,0,0,1-4.17-1.73A5.69,5.69,0,0,1,0,14.77V3A2.83,2.83,0,0,1,.87.87,2.83,2.83,0,0,1,3,0H23.63a2.82,2.82,0,0,1,2.08.87A2.83,2.83,0,0,1,26.58,3V7.38a2.84,2.84,0,0,1-.87,2.09,2.82,2.82,0,0,1-2.08.87h-3v4.43a5.91,5.91,0,0,1-5.9,5.9ZM20.67,7.38h3V3h-3Z"/></svg>
    </div>
);
export default SvgBrewBarIcon;
